__turbopack_context__.v({
  "bannerContainer": "nOZT7G_bannerContainer",
  "hiddenBanner": "nOZT7G_hiddenBanner",
  "progressBar": "nOZT7G_progressBar",
});
